import { CellModel, ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { GridEditorAdapter, GridEditorOptions, RowData } from "@reporting/rp-app-host";
import { Style as DefStyle } from "@reporting/rp-types/definition";

const PAGE_SIZE = 500;

export class TableStylesGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];
	private _styles: DefStyle[];

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;
		this._columns = [{
			t: 'a',
			e: false,
			w: 5 + 20 * 3,
			content: [{
				action: 'delete',
				title: msg('Delete'),
				icon: 'trash',
				color: ColorTypes.Red
			}, {
				action: 'duplicate',
				title: msg('Duplicate'),
				icon: 'copy',
				color: ColorTypes.Yellow
			}, {
				action: 'edit',
				title: msg('Edit'),
				icon: 'pen',
				color: ColorTypes.Blue
			}],
			filter: false,
			sorting: false,
		}, {
			data: 'id_style',
			header: '#',
			t: 'n',
			e: false,
			w: 60
		}, {
			data: 'description',
			header: msg('Description'),
			t: 't',
			e: true,
			w: 200
		}, {
			data: 'who_created',
			header: msg('Created by'),
			t: 't',
			e: false,
			w: 180
		}, {
			data: 'date_created',
			header: msg('Created'),
			t: 'dt',
			e: false,
			w: 145
		}, {
			data: 'idz',
			t: 'n',
			e: false,
			hidden: true
		}];
		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]> {
		this._styles = await rp.ms('definition').get<DefStyle[]>(`styles/T`, this.createRequestParams(filters, {
			fields: ['idz', 'id_style', 'description', 'who_created', 'date_created'],
			order: [['id_style', 'asc']],
			count: PAGE_SIZE
		}));
		return this._styles.map(data => ({ data }));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			pageSize: PAGE_SIZE,
			refreshAfterSave: true,
		});
	}

	async save(rowData: RowData[]) {
		const data = rowData.map(row => Object.assign({_state: row.state, _index: row.index}, row.data));
		await rp.ms('definition').post('styles/T', data);
	}

	onAction(action: string, cell: CellModel): void {
		switch (action) {
			case 'edit':
				if (!cell.row.data?.id_style) {
					rp.host.showAlert({content: msg('Save the row before editing.'), type: 'warning'});
					return;
				}
				rp.host.open(
					`definition-tableStyleEditor-${cell.row.data.id_style}`,
					{ title: `${cell.row.data.description ? cell.row.data.description : `${msg('Style')} #${cell.row.data.id_style}`}` }
				);
				break;
		}
	}
}
